import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

export default function VendorBalanceSummary({ Title, vendors }: any) {
	console.log(vendors, 'vendors');
	console.log(Title, 'Title');
	// ✅ Correct reduce
	let totalBalance;
	if ((Title as string) !== 'Total Vendor') {
		totalBalance = vendors?.reduce(
			(acc: number, vendor: any) => acc + (vendor?.balanceToSettle || 0),
			0
		);
	} else {
		totalBalance = vendors?.length || '-';
	}

	console.log(totalBalance, 'totalBalance');

	return (
		<Card
			sx={{
				minWidth: 250,
				background: '#f5f5f5',
				boxShadow: 3,
				borderRadius: 3,
			}}
		>
			<CardContent sx={{}}>
				<Typography gutterBottom>{Title}</Typography>
				<Typography variant="h5" color="primary" fontWeight="bold">
					{(Title as string) !== 'Total Vendor' ? '₹' : ''}{' '}
					{totalBalance.toLocaleString()}
				</Typography>
			</CardContent>
		</Card>
	);
}
